/** Scale used when a currency code cannot be resolved at all. */
export const DEFAULT_FRACTION_DIGITS = 2;

/**
 * Precision for codes the ISO tables (and therefore Intl) do not carry.
 * Must stay in sync with CurrencyProvider::COMMODITY_PRECISION / SDR_PRECISION.
 */
const APP_SPECIFIC_FRACTION_DIGITS: Record<string, number> = {
    XAU: 8,
    XAG: 8,
    SDR: 8,
};

/**
 * Derives a currency's precision without touching the network.
 *
 * The server is the source of truth, but money forms must stay usable while its
 * currency table is still loading — or never arrives. Intl carries the same ISO
 * minor-unit data the backend reads, so this is a faithful stand-in.
 */
export function localFractionDigits(currency: string | null | undefined): number {
    const code = (currency ?? '').trim().toUpperCase();

    const appSpecific = APP_SPECIFIC_FRACTION_DIGITS[code];
    if (appSpecific !== undefined) {
        return appSpecific;
    }

    try {
        const resolved = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: code,
        }).resolvedOptions().maximumFractionDigits;

        return resolved ?? DEFAULT_FRACTION_DIGITS;
    } catch {
        // Not a currency code Intl recognises.
        return DEFAULT_FRACTION_DIGITS;
    }
}
